import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { IonicInput } from 'ionic-ui';
import PhoneNumberInput from '../../../../../../ui/PhoneNumberInput';
import { WalletKyc } from '../../../../../../../schemas/wallet-kyc-schema';

export default function StoreInformationDialog() {
  const { control } = useFormContext<WalletKyc>();

  return (
    <div>
      <h6 className="medium-emphasis-text font-medium">
        Confirm Store information
      </h6>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-4">
        <Controller
          name="business_name"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="store name*"
                disabled
                placeholder="store name"
                hint={fieldState.error?.message ?? ''}
                hintClass={'text-destructive'}
              />
            </div>
          )}
        />

        <Controller
          name="business_registration_number"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="CAC Registration number*"
                placeholder="0123456789..."
                hint={fieldState.error?.message ?? ''}
                hintClass={'text-destructive'}
              />
            </div>
          )}
        />

        <Controller
          name="tin"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="Tax identification number(TIN)*"
                placeholder="0123456789..."
                hint={fieldState.error?.message ?? ''}
                hintClass={'text-destructive'}
              />
            </div>
          )}
        />

        <Controller
          name="business_type"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="store type*"
                type="select"
                ignorePortal={true}
                options={[
                  {
                    label: 'Sole Proprietor',
                    value: 'sole_proprietor',
                    disabled: false,
                  },
                  {
                    label: 'Partnership',
                    value: 'partnership',
                    disabled: false,
                  },
                  {
                    label: 'LLC',
                    value: 'llc',
                    disabled: false,
                  },
                  {
                    label: 'Public Corporation',
                    value: 'public_corp',
                    disabled: false,
                  },
                  {
                    label: 'NGO',
                    value: 'ngo',
                    disabled: false,
                  },
                  {
                    label: 'Cooperative',
                    value: 'cooperative',
                    disabled: false,
                  },
                ]}
                placeholder="store type"
                hint={fieldState.error?.message ?? ''}
                hintClass={'text-destructive'}
              />
            </div>
          )}
        />

        <Controller
          name="email"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="Store Email*"
                placeholder="Store Email"
                hint={fieldState.error?.message ?? ''}
                hintClass={'text-destructive'}
              />
            </div>
          )}
        />

        <Controller
          name="phone"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <PhoneNumberInput
                {...field}
                label="store phone number*"
                size="lg"
                placeholder="e.g. 0801 234 5678"
                hint={fieldState.error?.message ?? ''}
                hintClass={'text-destructive'}
              />
            </div>
          )}
        />

        <Controller
          name="registration_info.incorporation_date"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="Incorporation date*"
                placeholder="YY-MM-DD"
                type="date"
                value={field.value?.trim()}
                hint={fieldState.error?.message}
                hintClass="text-destructive"
              />
            </div>
          )}
        />

        <Controller
          name="registration_info.registered_office"
          control={control}
          render={({ field, fieldState }) => (
            <div>
              <IonicInput
                {...field}
                label="Registered office*"
                placeholder="E.g. Lagos, Nigeria"
                hint={fieldState.error?.message ?? ''}
                hintClass={'text-destructive'}
              />
            </div>
          )}
        />
        <Controller
          name="wallet_preferred_name"
          control={control}
          render={({ field, fieldState, formState }) => (
            <div>
              <IonicInput
                {...field}
                label="preferred wallet name"
                placeholder={
                  formState.defaultValues?.business_name || 'E.g Wallet_1'
                }
                hint={fieldState.error?.message ?? ''}
                hintClass={'text-destructive'}
              />
            </div>
          )}
        />
      </div>
    </div>
  );
}
